import {CardDescription, CardDescriptionWithCount, SingleCard} from '../types';

const DEFAULT_COUNT = 0;

export const getFullCardsInfo = (
    cardTypes: CardDescription[],
    initialCardStates: SingleCard[]
): CardDescriptionWithCount[] => {
  return cardTypes?.map((card) => {
    const initialCount = initialCardStates.find(
        ({type}) => type === card.code
    )?.count || DEFAULT_COUNT;

    return {
      ...card,
      count: initialCount
    };
  });
};
